			document.addEventListener("DOMContentLoaded", function () {
				const targets = document.querySelectorAll(".fadein");

				const observer = new IntersectionObserver(
					(entries) => {
						entries.forEach((entry) => {
							if (entry.isIntersecting) {
								entry.target.classList.add("is-show");
							}
						});
					},
					{
						threshold: 0.1,
					}
				);
				targets.forEach((target) => observer.observe(target));
			});


			document.addEventListener("DOMContentLoaded", function () {
				const isPC = window.innerWidth >= 961; // 961px以上の指定

				const swiper = new Swiper(".moveBox04 .swiper", {
					loop: true,
					speed: 1500,
					slidesPerView: 1,
					centeredSlides: false,
					effect: "fade",
					fadeEffect: {
						crossFade: true, // fade + loop の場合はcrossFade必須
					},
					autoplay: {
						delay: 2500, //3000から変更
						pauseOnMouseEnter: true,
						disableOnInteraction: false,
					},
					simulateTouch: true, // 両方でドラッグ／スワイプ可
					allowTouchMove: true,
					observer: true, // DOM変化を監視
					observeParents: true, // 親要素の変化にも反応
				});
				// --- Shopifyの遅延描画・画像読み込みに備えて遅延初期化 ---
				setTimeout(initSwiper, 600); // ← fadeが効かない原因の多くはここで解決

				// ウィンドウリサイズで再初期化（PC切替対策）
				window.addEventListener("resize", () => {
					setTimeout(initSwiper, 300);
				});

				let swiper02;
				// 有効化時のオプションを記述
				function initializeSwiper() {
					swiper = new Swiper(".swiper02", {
						loop: true,
						speed: 1500,
						slidesPerView: 1,
						centeredSlides: false,
						effect: "fade",
						autoplay: {
							delay: 2500,
							disableOnInteraction: false,
						},
					});
				}
				// 無効化する用の記述
				function destroySwiper() {
					if (swiper02) {
						swiper02.destroy();
						swiper02 = undefined;
					}
				}
				// if分を用いて横幅に応じて関数を実行
				function handleResize() {
					var w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
					if (w < 961) {
						if (!swiper02) {
							initializeSwiper();
						}
					} else {
						destroySwiper();
					}
				}
				// 初回実行
				handleResize();
				window.addEventListener("resize", handleResize);
			});
